module.exports = __webpack_public_path__ + "img/marine_app_8.34da1da7.jpg";